import { mapGeoOptions } from '../geoCountryNames';
const API_BASE_URL = process.env.REACT_APP_BASE_API_URL

export const fetchFilterOptions = async (endpoint, lang = 'ru') => {

    const token = localStorage.getItem('token');

    try {
        const response = await fetch(`${API_BASE_URL}${endpoint}`, {
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        if (!response.ok) {
            throw new Error('Ошибка при загрузке фильтров');
        }
        const data = await response.json();

        const items = data?.data || [];

        if (endpoint.includes('/filters/geos')) {
            return mapGeoOptions(items, lang);
        }

        return items;
    } catch (error) {
        console.error(`[fetchFilterOptions] Ошибка при загрузке данных с ${endpoint}:`, error);
        return [];
    }
};

